import notify from 'devextreme/ui/notify';
import gsap from "gsap";
export default {
  data() {
    return {
      locCheck:[],
      infoCheck:[],
      eviCheck:[],
      actCheck:[],
      infoAdded:false
      
    };
  },
  mounted() {
   
  },

  computed: {
    knownDocs(){
        return this.$store.getters.getKnownDocs
      }

  },
  methods: {
      getMaps(content){
        let mapIDs=[]
        let map
        if(!content || content.indexOf("-----")>=0){
            return
          }
          for(var i in content){
            map=content[i].split(" ")[0]
            mapIDs.push(map)
             this.$store.dispatch('loadMap',map) 
             this.$store.commit('setCurrentMap',map)  
          }
          return mapIDs
      },
      getInfo(content){
        let infoItems=[]
        let info
        
        let entry
        console.log("Get INFO",content)
        if(!content){
          return
        }
        if(content.indexOf("-----")>=0){
          return
        }
        this.infoAdded=true
        for(var i in content){
         
             
          info=content[i].split(":")
          entry=info.shift()
          infoItems.push({entry:entry,desc:info.join(" ")})
          if(!this.knownDocs.includes(entry)){
            this.infoAdded=false
          }
          if(this.infoAdded){
            this.infoCheck[0]=true
          }
        }
        console.log("Get INFO2",infoItems)
        return infoItems
    },
      getEvidence(content){
          let evidenceIDs=[]
          let evi
          if(content.indexOf("-----")>=0){
            return
          }
          for(var i in content){
            evi=content[i].split(" ")[0]
            evidenceIDs.push(evi)
            //if(this.evidenceItem(evi)){
            
            if(this.knownDocs.includes(this.evidenceItem(evi).id)){
               this.eviCheck[i]=true
              }else{
               this.eviCheck[i]=false
              }
              console.log("EVI CHECK",this.eviCheck)
              if(!this.$store.getters.getEvidence(evi)) {
                this.$store.dispatch('loadEvidence',evi)   
              }
            } 
          //}
          //loadEvidence
          console.log("evidence",evidenceIDs)
          return evidenceIDs
      },
      getActions(content){
        
          let actions=[]
          let action
          if(!content){
            return
          }
          if(content.indexOf("-----")>=0){
            return
          }
          console.log("ACTION CONTENT",content)
          for(var i in content){
            action=content[i]
            actions.push(action)
             if(this.knownDocs.includes(this.actionItem(action).id)){
               this.actCheck[i]=true
              }else{
               this.actCheck[i]=this.actCheck[i] || false
              } 
          }
          return actions
      },
    docDelay(id){
        let delay=2
        switch(id.split("-")[0]){
          case "Exp":
            delay=5
            break;
          case "Doc":
            delay=1 
            break;
          case "Loc":
            delay=0
            break;
          case "Evi":
            delay=0
            break;
          case "Map":
            delay=3
            break;
          case "Info":
            delay=0
            break;
          }
          
          return delay
    },
    docType(id){
        if(Array.isArray(id)){
          id=id[0]
        }
        let dtype=id.split("-")[0]
        switch(id.split("-")[0]){
          case "Exp":
            dtype= "Experts"
            break;
          case "expert":
            dtype= "Experts"
            break;
          case "Doc":
            dtype="Documents"  
            break;
          case "Loc":
            dtype="Locations"
            break;
          case "Evi":
            dtype="Evidence"
            break;
          case "Map":
            dtype="Map"
            break;
          case "Info":
            dtype="Info"
            break;
          case "Act":
            dtype="Action"
            break;
          }
          
          return dtype
      },
      async loadAction(action){
        await this.$store.dispatch('loadAction',action.id)
       let actionDetails= this.$store.getters.getAction(action.id)
        
        if(actionDetails.type=="info"){
          gsap.delayedCall(0,this.addInfo,[action.info]) 
          this.findDoc(actionDetails)
        }else{
          if(Array.isArray(actionDetails.delay) || actionDetails.delay>0){
            console.log("NOTIFY",actionDetails)
            if(Array.isArray(actionDetails.link)){
              let hideSearch=true;
              for(var i in actionDetails.link){
                if(i==actionDetails.link.length-1){
                  hideSearch=false
                }
                let newAction={name:actionDetails.name[i],
                              result:actionDetails.result[i],
                              delay:actionDetails.delay[i],
                              link:actionDetails.link[i],
                              type:actionDetails.type[i]}
                if(actionDetails.searchText){
                  newAction.searchText=actionDetails.searchText[i]
                } 
                if(actionDetails.foundText){
                  newAction.foundText=actionDetails.foundText[i]
                }             
                if(newAction.delay>0){
                  this.$store.commit('addNotification',{task:newAction.name,result:newAction.result,time:newAction.delay,searchText:newAction.searchText, foundText:newAction.foundText,hideSearch:hideSearch}) 
                  gsap.delayedCall(newAction.delay,this.findDoc,[newAction]) 
                }else{
                  this.findDoc(newAction)
                }
                
              }
            }else{
              console.log("ELSE",actionDetails)
              this.$store.commit('addNotification',{task:actionDetails.name,searchText:actionDetails.searchText,foundText:actionDetails.foundText,result:actionDetails.result,time:actionDetails.delay}) 
              gsap.delayedCall(actionDetails.delay,this.findDoc,[actionDetails])  
            }
            
          }else{
            this.findDoc(actionDetails)
          }
         
        }
        this.currentItem++
       // gsap.delayedCall(7,this.findDoc,[action])  
        //this.$store.commit("setCurrentMap","Map-001")
     },
       doAction(action,checked){
         if(checked){
          if(this.docType(action.id)=="Evidence"){
            this.$store.dispatch("showBasicHelp","You have already discovered this.")
         }else{
          this.$store.dispatch("showBasicHelp","You have already done this.")
         }
           return
         }
        console.log("DO ACTION",action)
        if(this.docType(action.id)=="Action"){
          this.$store.commit('findDoc',action)
          this.loadAction(action)
          return
        }
       // 
       if(this.docType(action.id)=="Evidence"){
        
          this.$store.commit('findDoc',{type:"Evidence",id:action.id})
          this.$store.commit('addNotification',{task:"-"+action.name,result:action.name,time:0,foundText:"Evidence Added",searchText:"Evidence Added"}) 
              
         
        return
       }
        
       // 
        this.currentItem++
        if(action.info){
          console.log("Add INFO - action.info",action)
          gsap.delayedCall(0,this.addInfo,[action.info]) 
        }
        if(this.docDelay(action.id)>0){
          if(!action.info || true){
            notify({ message: action.text, 
                animation: this.animation,width: 300, shading: false,position:"top right" }, "info", 3000)   
            }
            gsap.delayedCall(7,this.findDoc,[action])  
        }else{
            console.log("doAction findDoc")
            this.findDoc(action)
        } 
         
      },
      addInfo(infoList){
        for(var i in infoList){
          console.log("add info",infoList,infoList[i])
          this.$store.commit('findDoc',{id:infoList[i]})
        }
        if(false){
          notify({ message: "Info added.", 
          animation: this.animation
          ,width: 300, shading: false,position:"top right" }, "info", 3000) 
        }
       
      },
      findDoc(action){
       console.log("FIND DOC",action)
        
        let dtype=this.docType(action.type)
        
        let link=action.link
        let result=action.result || dtype+" FOUNDXXX "+link
        let searchText=action.searchText || "Document Scanned"
        if(dtype=="Info" || action.type=="info"){
         
          for(var i in this.infoList){
            this.$store.commit('findDoc',{id:this.infoList[i].entry})
          }
          
          this.$store.commit('addNotification',{task:"Wreck info added",result:"Wreck info added",time:2,foundText:result,searchText:searchText}) 
           
         // notify({ message: "Wreck info added.", 
        //  animation: this.animation
        //  ,width: 300, shading: false,position:"top right" }, "info", 3000)   
        }else{
          if(action.extraInfo){
            for(var i in action.extraInfo){
              this.$store.commit('findDoc',{id:action.extraInfo[i]})
            }
          }
          if(dtype=="Locations"){
            
            this.addLocMap(link)
          }
          if(dtype=="Evidence"){
            this.$store.commit('findDoc',{type:dtype,id:action.id})
            return
          }
        if(Array.isArray(link)){
          for(var i in link){
            this.$store.commit('findDoc',{type:dtype,id:link[i]})
          }
         
        }else{
          console.log("FIND DEFALUT",dtype,link)
          if(link){
            this.$store.commit('findDoc',{type:dtype,id:link})
          }
          
        }
        
       /* notify({ message:result, 
         animation: this.animation
         ,width: 300, shading: false,position:"top right" }, "info", 3000)  
         */ 
        }
      },
      async addLocMap(id){
        
        await this.$store.dispatch("retreiveLocation",id)
        let loc =this.$store.getters.getLocation(id)
        if(loc && loc.map){
          this.$store.commit('findDoc',{id:loc.map})
        }
      },
     
      evidenceItem(id){
        
        let item=this.$store.getters.getEvidence(id)
        
        if(item){
          return item
          //return item.name+":"+item.value
        }else{
           return {description:id}
        }
        },
       actionItem(itemText){
        let itemArray=itemText.split(" ")
        let item={}
        let content
        if(itemArray.length>0){
          item.id=itemArray.shift()
          content=itemArray.join(" ").split("-")
          item.text=content.shift()
          if(content){
            item.info=content.join("-").split(",")
          }
          
          return item
          //return item.name+":"+item.value
        }else{
           return {text:itemText}
        }
          
      },
  }
  
}